// Thin-line icons (1.25 px strokes, 24 px grid). Constants only: nothing here comes from data.
import { raw } from '../dom.js';

const I = {
  search: '<path d="M10.5 18a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15Zm5.3-2.2L21 21"/>',
  arrow: '<path d="M7 17 17 7M9 7h8v8"/>',
  close: '<path d="m6 6 12 12M18 6 6 18"/>',
  check: '<path d="m5 12.5 4.2 4L19 7"/>',
  plus: '<path d="M12 5v14M5 12h14"/>',
  minus: '<path d="M5 12h14"/>',
  home: '<path d="M4 11.5 12 5l8 6.5V20h-5v-5h-6v5H4z"/>',
  full: '<path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"/>',
  play: '<path d="M8 5.5v13l10.5-6.5z"/>',
  pause: '<path d="M8 5v14M16 5v14"/>',
  aurora: '<path d="M3 17c3-6 5-9 9-9s6 3 9 9M6 17c2-4 3.5-6 6-6s4 2 6 6M12 3v2M5 6l1.4 1.4M19 6l-1.4 1.4"/>',
  snow: '<path d="M12 3v18M4.2 7.5l15.6 9M4.2 16.5l15.6-9M9.5 4.5 12 7l2.5-2.5M9.5 19.5 12 17l2.5 2.5"/>',
  tour: '<path d="M12 21s-6.5-5.6-6.5-11a6.5 6.5 0 1 1 13 0c0 5.4-6.5 11-6.5 11Z"/><circle cx="12" cy="10" r="2.3"/>',
  prev: '<path d="M15 5 8 12l7 7"/>',
  next: '<path d="m9 5 7 7-7 7"/>',
  menu: '<path d="M4 8h16M4 16h10"/>',
  gauge: '<path d="M4.2 16.5a8 8 0 1 1 15.6 0"/><path d="m12 15.5 3.6-4.6"/><circle cx="12" cy="15.5" r="1.1"/>',
  tree: '<path d="M12 3 7.5 10h2.6L6 15.5h4.2L12 21l1.8-5.5H18L13.9 10h2.6L12 3Z"/>', // WS-18: tree settings
  sun: '<circle cx="12" cy="12" r="4"/><path d="M12 2.5v2M12 19.5v2M2.5 12h2M19.5 12h2M5.3 5.3l1.4 1.4M17.3 17.3l1.4 1.4M5.3 18.7l1.4-1.4M17.3 6.7l1.4-1.4"/>',
  // round 6: season switch, custom date, panel fold
  leaf: '<path d="M5 19C5 10 10 5 20 4c0 9-5 15-13 15H5Z"/><path d="M5 19c3-5 6-8 10-10"/>',
  sprout: '<path d="M12 21v-9M12 12c0-4-3-6-7-6 0 4 3 6 7 6ZM12 14c0-4 3-6 7-6 0 4-3 6-7 6Z"/>',
  calendar: '<rect x="4" y="5.5" width="16" height="14.5" rx="2.5"/><path d="M4 10h16M8.5 3.5v4M15.5 3.5v4"/>',
  fold: '<path d="m6 15 6-6 6 6"/>',
  info: '<circle cx="12" cy="12" r="8.5"/><path d="M12 11v5.5M12 7.6v.2"/>', // WS-45: map-data credit
  layers: '<path d="m12 4 8 4.5-8 4.5-8-4.5L12 4Z"/><path d="m4 13 8 4.5 8-4.5"/>', // WS-49: the client's layers
  locate: '<path d="M20 4 4 10.8l7 2.2 2.2 7L20 4Z"/>', // WS-91: "Show where I am" (the arrow a map app uses)
  route: '<circle cx="6" cy="18" r="2"/><circle cx="18" cy="6" r="2"/><path d="M8 18h7.5a3 3 0 0 0 0-6h-7a3 3 0 0 1 0-6H16"/>', // WS-91: Directions on a card
  pin: '<path d="M12 21s-6.5-5.6-6.5-11a6.5 6.5 0 0 1 13 0c0 5.4-6.5 11-6.5 11Z"/><circle cx="12" cy="10" r="2.3"/>', // a client's pin among the "Where to?" results
};
export const hasIcon = (name) => typeof name === 'string' && Object.hasOwn(I, name); // a name from data is looked up, never drawn as markup
export const icon = (name, cls = '') => raw(`<svg class="ic ${cls}" viewBox="0 0 24 24" aria-hidden="true">${I[name]}</svg>`);

const CAT_ICON = {
  stay: '<path d="M3 20h18M5 20V11l7-6 7 6v9M10 20v-5h4v5"/>',
  dining: '<path d="M7 3v8a2 2 0 0 0 2 2v8M7 3v6M11 3v6M17 21V3c-2 1.5-3 4-3 7h3"/>',
  wellness: '<path d="M12 21c4 0 7-3 7-7 0-5-7-11-7-11S5 9 5 14c0 4 3 7 7 7Z"/>',
  activities: '<path d="M6 4c1 2 1 3 0 5M10 4c1 2 1 3 0 5M4 20l3-8h10l3 8M8 16h8"/>',
  outdoors: '<path d="M12 3 4 17h16L12 3ZM12 17v4M8.5 11h7"/>',
  services: '<circle cx="12" cy="12" r="8.5"/><path d="M12 7.5v5l3 2"/>',
};
export const catIcon = (id) => raw(`<svg class="ic" viewBox="0 0 24 24" aria-hidden="true">${CAT_ICON[id] || CAT_ICON.services}</svg>`); // lookup by id

// A single place's own icon (`icon` of its content entry: a reindeer park, a ride's kind), drawn in css/places.svg;
// a place without one, or with a name that is not a plain icon name, keeps its category's
const PLACE_SPRITE = new URL('../../css/places.svg', new URL("chrome/icons.js", import.meta.url).href).href;
export const placeIcon = (p, cat = p?.category) => (typeof p?.icon === 'string' && /^[a-z][a-z-]{0,23}$/.test(p.icon) ? raw(`<svg class="ic pl" viewBox="0 0 24 24" aria-hidden="true"><use href="${PLACE_SPRITE}#${p.icon}"></use></svg>`) : catIcon(cat));
